
import { Mail, Phone, Instagram } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import NavMenu, { MobileNavMenu } from "./NavMenu";

const Header = () => {
  const isMobile = useIsMobile();

  return (
    <div className="sticky top-0 z-50 bg-primary/5 shadow-sm backdrop-blur-sm">
      {/* Contact info bar */}
      <div className="py-1 sm:py-2 border-b border-primary/10">
        <div className="container mx-auto px-2 sm:px-4">
          <div className="flex flex-col sm:flex-row items-center justify-between">
            <div className="flex items-center">
              <img 
                src="/lovable-uploads/42310d0b-7300-4943-aa0d-6049fe9e48ea.png" 
                alt="All-Star Basketball and Physical Education Academy Logo" 
                className="h-10 w-10 sm:h-14 sm:w-14 mr-2 sm:mr-4"
              />
            </div>
            <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-6 text-xs sm:text-sm">
              <a
                href="mailto:talentevaluator@yahoo.com"
                className="flex items-center gap-1 sm:gap-2 hover:text-secondary transition-colors"
              >
                <Mail className="h-3 w-3 sm:h-4 sm:w-4" />
                {isMobile ? "Email" : "talentevaluator@yahoo.com"}
              </a>
              <a
                href="tel:704-533-6177"
                className="flex items-center gap-1 sm:gap-2 hover:text-secondary transition-colors"
              >
                <Phone className="h-3 w-3 sm:h-4 sm:w-4" />
                704-533-6177
              </a>
              <a
                href="https://www.instagram.com/all_starbasketballacademy/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1 sm:gap-2 hover:text-secondary transition-colors"
              >
                <Instagram className="h-3 w-3 sm:h-4 sm:w-4" />
                {isMobile ? "IG" : "@all_starbasketballacademy"}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation menu */}
      <div className="py-2">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between">
            <div className="text-sm sm:text-lg md:text-xl font-bold text-primary">
              {/* Removed name text */}
            </div>
            <div className="flex items-center">
              <NavMenu />
              <MobileNavMenu />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
